import Backbone from 'backbone';
import { AppConfig } from '@ve/types';

declare const $: any;
interface ExWindow extends Window {
    appConfig: AppConfig
}

declare let window: ExWindow;

export default (tourCriteria: Backbone.Model): void => {
    const checkInDateRange = tourCriteria.get('checkInDateRange');
    const dateFrom = checkInDateRange !== null ? $.datepicker.formatDate('dd.mm.yy', checkInDateRange.get('from')) : '';

    const countries = tourCriteria.get('countries');
    const toCountry = countries !== null ? countries.at(0).get('name') : '';

    const title = `${toCountry} ${dateFrom ? `c ${dateFrom}` : ''}`;

    const { showcaseTitle } = window.appConfig;
    const result = showcaseTitle ? `${title} | ${showcaseTitle}` : title;
    document.title = result;
    window.appConfig.dynamicTitle = result;
};